import React, { useEffect, useMemo, useCallback } from "react"
import './apppage.scss'
import NavBar from "../../Components/NavBar/navbar.component"
import { Layout } from "antd"
import { Footer, Content } from "antd/es/layout/layout"
import { Outlet, useNavigate } from "react-router-dom"
import { socket } from "../../socket"

const AppPage = () => {
    const navigate = useNavigate();

    const orderAudio = useMemo(
        () => {
            const audio = new Audio('/audio/order_alert.mp3')
            audio.loop = true
            return audio
        },
        []
    )

    const playAudio = useCallback(() => {
        orderAudio.play().catch((err) => console.log(err))
    }, [orderAudio])

    const stopAudio = useCallback(() => {
        orderAudio.pause()
        orderAudio.currentTime = 0
    }, [orderAudio])

    useEffect(() => {
        const handleStopAudio = () => stopAudio()
        window.addEventListener('stopOrderAudio', handleStopAudio)
        return () => window.removeEventListener('stopOrderAudio', handleStopAudio)
    }, [stopAudio])

    useEffect(() => {
        if ("Notification" in window && Notification.permission === "default") {
            Notification.requestPermission();
        }
    }, []);

    useEffect(() => {
        const handleNewOrder = (data: any[]) => {
            if (data && data.length > 0) {
                console.log('New orders received (Global), playing audio and navigating to dashboard');
                playAudio();
                
                if ("Notification" in window && Notification.permission === "granted") {
                    new Notification("New Order Received!", {
                        body: "You have a new order waiting."
                    });
                }
                
                navigate('/vendor/app/dashboard', { state: { orderOptions: 'New', timestamp: Date.now() } });
            }
        };

        socket.on('neworder', handleNewOrder);
        return () => {
            socket.off('neworder', handleNewOrder);
        };
    }, [navigate, playAudio]);

    return <Layout style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
        <NavBar />
        <Content style={{ flex: '1 0 auto' }}>
            <Outlet />
        </Content>
        <Footer style={{ textAlign: 'center', width: '100%' }}>
            Foodtolls ©{new Date().getFullYear()} Created by Ant UED
        </Footer>
    </Layout>
}

export default AppPage